import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { CompanyService, Company } from "app/services/company.service";
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { BaseComponent } from "app/components/base.component";
import { NotificationsService } from "angular2-notifications";

@Component({
	selector: 'app-companies-add-edit',
	templateUrl: './companies-add-edit.component.html',
	styleUrls: ['./companies-add-edit.component.less']
})
export class CompaniesAddEditComponent extends BaseComponent implements OnInit {

	param_id: string;
	item: Company;

	formTitle: string = 'Add Company';
	buttonText: string = 'Save Company';

	companyForm: NgForm;
	@ViewChild('companyForm') currentForm: NgForm;

	constructor(
		private companyService: CompanyService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService
	) {
		super();
	}

	ngOnInit() {
		this.item = new Company()
		this.param_id = this.route.snapshot.params['id'];
		if (this.param_id) {
			this.formTitle = 'Edit Company';
			this.buttonText = 'Update Company';
			this.companyService.getCompany(this.param_id).subscribe(company => {
				this.item = company;
			});
		}
	}

	formAction() {
		var self = this;

		if (!this.formValidation(false)) {
			window.scrollTo(0,0);
		}else{
			if (this.param_id) {
				this.companyService.updateCompany(this.param_id, this.item).then(function(){
					self.notificationsService.success('Updated', '1 company updated')
				}).catch(function(e){
					console.log('there is an error. '+ e.message)
				});
			}
			else {
				this.companyService.addCompany(this.item).then(function(){
					self.notificationsService.success('Added', '1 company added')
				}).catch(function(e){
					console.log('there is an error. '+ e.message)
				});
			}
			this.router.navigate(['/company']);
		}
	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.companyForm) { return; }

		this.companyForm = this.currentForm;
		if (this.companyForm) {
			this.companyForm.valueChanges
				.subscribe(data => {
					this.formValidation(true)
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.companyForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}

		return form.valid;
	}

	formErrors = {
		'name': '',
		'street_one': '',
		'city': '',
		'postal_code': '',
		'country_key': '',
		'phone': '',
		'fax': '',
		'email': '',
		'attn': '',
		'type': '',
	};

	validationMessages = {
		'name': {
			'required': 'This field is required.',
		},
		'street_one': {
			'required': 'This field is required.',
		},
		'city': {
			'required': 'This field is required.',
		},
		'postal_code': {
			'required': 'This field is required.',
		},
		'country_key': {
			'required': 'This field is required',
		},
		'phone': {
			'required': 'This field is required.',
			'pattern': 'Please provide a valid phone format.'
		},
		'fax': {
			'pattern': 'Please provide a valid fax format.',
		},
		'email': {
			'pattern': 'Please provide a valid email format.',
		},
		'attn': {
			'required': 'This field is required.',
		},
		'type': {
			'required': 'This field is required.',
		},
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/company/companies-add-edit/companies-add-edit.component.ts